import {
  Box,
  Button,
  HStack,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { XCircle } from "phosphor-react";
import * as yup from "yup";
import React, { useState } from "react";
import { useFormik } from "formik";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import "react-datepicker/dist/react-datepicker.css";
import { COLORS } from "../../Helper/Colors";
import { FormInput } from "../../Components/Common/UI";
import Api from "../../Helper/ApiHandler";

const EditStaticPage = ({ type, initialValues, onClose, handleModal }) => {
  const config = {
    toolbar: {
      items: [
        "heading",
        "fontfamily",
        "fontsize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "strikethrough",
        "underline",
        "blockQuote",
        "|",
        "link",
        "|",
        "alignment:left",
        "alignment:right",
        "alignment:center",
        "alignment:justify",
        "outdent",
        "indent",
        "|",
        "bulletedList",
        "numberedList",
      ],

      shouldNotGroupWhenFull: true,
    },
    link: {
      addTargetToExternalLinks: true,
    },
  };
  const toast = useToast();
  const api = new Api();
  const [btnLoading, setBtnLoading] = useState(false);
  const schema = yup.object().shape({
    title: yup.string().required("Title is required!"),
    content: yup.string().required("Content is required!"),
  });
  const handleSubmit = async (values) => {

    setBtnLoading(true);

    let data = await api.put("auth/static-content/edit", values);
    toast({
      description: `${data.message}`,
      status: "success",
      duration: 3000,
      isClosable: false,
      position: "top",
    });

    setBtnLoading(false);
    onClose(true);
  };
  const formik = useFormik({
    initialValues: {
      id: initialValues._id,
      content: initialValues.content,
      title: initialValues.title,
    },
    validationSchema: schema,
    onSubmit: handleSubmit,
  });
  const onEditorStateChange = (event, editor) => {
    formik.setFieldTouched("content", true);
    formik.setValues({ ...formik.values, content: editor.getData() });
  };

  const handleChange = (name, value) => {
    formik.setFieldTouched(name, true, true);
    formik.setValues({ ...formik.values, [name]: value });
  };

  const { values, touched, errors } = formik;
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      width={"100%"}
      height={"100%"}
      overflow={"auto"}
      padding={4}
      paddingBottom={2}
    >
      <ModalHeader
        display={"flex"}
        flex="1"
        width={"100%"}
        justifyContent={"space-between"}
        alignItems="center"
      >
        <HStack
          display={"flex"}
          justifyContent={"center"}
          flex="1"
          alignItems="center"
          fontWeight={"600"}
        >
          <Text ml={1}>Edit static page/{initialValues.title}</Text>
        </HStack>
        <XCircle
          height="24"
          width="24"
          onClick={onClose}
          cursor={"pointer"}
          color={COLORS.lightGray}
        />
      </ModalHeader>
      <form
        onSubmit={formik.handleSubmit}
        style={{ overflow: "auto" }}
        className={"design-scrollbar"}
      >
        <ModalBody className={"design-scrollbar"}>
          <VStack spacing={4} width={"100%"} alignItems={"stretch"}>
            <FormInput
              onBlur={formik.handleBlur}
              type="text"
              name="title"
              label="Title"
              placeholder="Enter Title"
              value={values.title}
              isDisabled="true"
              error={!!touched.title && errors.title}
              onChange={(e) => handleChange("title", e.target.value)}
              errorMsg={errors.title}
            />
          </VStack>
          <Text marginTop={"15px"}>Content</Text>
          <Box>
            <CKEditor
              onReady={(editor) => {
                editor.ui
                  .getEditableElement()
                  .parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                  );
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "320px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              onChange={(event, editor) => onEditorStateChange(event, editor)}
              editor={DecoupledEditor}
              data={initialValues.content}
              config={config}
            />
          </Box>
          {formik.errors.content ? (
            <Text color={"red"}>{formik.errors.content}</Text>
          ) : null}
        </ModalBody>
        <ModalFooter justifyContent={"flex-start"}>
          <Button
            size={"lg"}
            type="submit"
            colorScheme="brand"
            className="custom-btn"
            marginTop={"15px"}
            width={"250px"}
          >
            Submit
          </Button>
        </ModalFooter>
      </form>
    </Box>
  );
};

export default EditStaticPage;
